import {baseURL, request} from './network';

// 封装接口请求
// export function 接口名() {
    // return 封装的请求名('请求方式', `${公用地址}请求地址`, 开启异步请求, 传参)
// }

// 获取首页数据
export function getIndexInfo(params) {
    return request('post', `${baseURL}/api/article/indexContent`, true, params)
}


// 获取文章列表
export function getList(params) {
    return request('post', `${baseURL}/api/article/getList`, true, params)
}

// 获取分类
export function getTree(params) {
    return request('post', `${baseURL}/api/article/cate/getTree`, true, params)
}

// 获取文章详情
export function getInfo(params) {
    return request('post', `${baseURL}/api/article/getInfo`, true, params)
}

// 星级诚信企业列表查询
export function getListStarCompany(params) {
    return request('post', `${baseURL}/api/company/listStarCompany`, true, params)
}
// 企业详情
export function getListStarInfo(params) {
    return request('post', `${baseURL}/api/company/infoById`, true, params)
}

// 诚信标杆企业列表查询
export function getListExampleCompany(params) {
    return request('post', `${baseURL}/api/company/exampleCompany`, true, params)
}

// 信用专家列表
export function getExpertList(params) {
    return request('post', `${baseURL}/api/personInfo/listCreditExpert`, true, params)
}
// 诚信企业家列表
export function getEnterpreneurList(params) {
    return request('post', `${baseURL}/api/personInfo/listEnterpreneur`, true, params)
}

// 人物详情
export function getPersonInfo(params) {
    return request('post', `${baseURL}/api/personInfo/infoById`, true, params)
}

// 信用企业列表查询
export function getCreditCompany(params) {
    return request('post', `${baseURL}/api/companyRating/list`, true, params)
}
// 信用企业详情
export function getCreditCompanyInfo(params) {
    return request('post', `${baseURL}/api/companyRating/infoById`, true, params)
}

// 信用评价
export function getCreditEvaluationList(params) {
    return request('post', `${baseURL}/api/article/creditEvaluationList`, true, params)
}

// *******************************************************企业诚信官**********************************************************************

// 企业诚信官首页置顶
export function qycxgIndex(params) {
    return request('post', `${baseURL}/api/rotationChart/qycxgIndex`, true, params)
}

// 优秀学员列表
export function getGoodStudents(params) {
    return request('post', `${baseURL}/api/personInfo/listStudent`, true, params)
}

// 师资介绍列表
export function getListTeacher(params) {
    return request('post', `${baseURL}/api/personInfo/listTeacher`, true, params)
}


